// extracted by mini-css-extract-plugin
export default {"field":"StaticValueField_field__SJF3B","error":"StaticValueField_error__U1HxR","label":"StaticValueField_label__IUwea","addon":"StaticValueField_addon__D-8kx"};